import React from 'react';
import { Route, Routes } from 'react-router-dom';
// import { read, utils } from 'xlsx';

import Layout from '../components/Layout';
import { data, details } from '../data';
import { useData, useSleepMode } from '../hooks';

import About from './About';
import FloatingIdeas from './FloatingIdeas';
import Idle from './Idle';
import Score from './Score';
import StructuredPlans from './StructuredPlans';

const App = () => {
  const { setStartTime } = useSleepMode();
  const { setScores, setDetails } = useData();

  React.useEffect(() => {
    // Todo: Fetching data from local file
    // (async () => {
    //   /* Download file */
    //   const res = await fetch(`${process.env.PUBLIC_URL}/scores.xlsx`);
    //   const value = await res.arrayBuffer();
    //   const wb = read(value); // parse the array buffer
    //   const ws = wb.Sheets[wb.SheetNames[0]]; // get the first worksheet
    //   const data: Array<IScore> = utils.sheet_to_json(ws); // generate objects
    //   console.log({ data });
    //   setScores(data);
    // })();
    setScores(data);
    setDetails(details);
  }, []);

  React.useEffect(() => {
    document.addEventListener('click', () => {
      setStartTime(Date.now());
    });
    document.addEventListener('touchstart', () => {
      setStartTime(Date.now());
    });
    document.addEventListener('touchend', () => {
      setStartTime(Date.now());
    });

    return () => {
      document.removeEventListener('click', () => setStartTime(Date.now()));
      document.removeEventListener('touchstart', () =>
        setStartTime(Date.now()),
      );
      document.removeEventListener('touchend', () => setStartTime(Date.now()));
    };
  }, []);

  return (
    <Routes>
      <Route path="/idle" element={<Idle />} />
      <Route path="/" element={<Layout />}>
        <Route path="/" element={<FloatingIdeas />} />
        <Route path="overview" element={<StructuredPlans />} />
      </Route>
      <Route path="/score" element={<Layout />}>
        <Route path="/score:scoreId" element={<Score />} />
      </Route>
      <Route path="/about" element={<Layout />}>
        <Route path="/about:aboutId" element={<About />} />
      </Route>
      <Route path="*" element={<div>Not Found</div>} />
    </Routes>
  );
};

export default App;
